/**
 * @file 从 NewRegionSelect 搜索框读 keyword 做高亮的文案组件
 */
import React, { useState, useEffect, useRef } from 'react';
import HighlightText from '@/pages/aigc/components/HighlightText';

export interface ISearchAwareTextProps {
  /** 展示名 */
  name: string;
  className?: string;
  /** 外部传入高亮词；有值时不读 NR 搜索框 DOM */
  keyword?: string;
}

/** 从 NewRegionSelect 搜索框或 props 读 keyword 做高亮 */
const SearchAwareText: React.FC<ISearchAwareTextProps> = ({
  name,
  className,
  keyword: keywordProp,
}) => {
  const [domKeyword, setDomKeyword] = useState('');
  const ref = useRef<HTMLSpanElement>(null);
  const keyword = keywordProp !== undefined ? keywordProp : domKeyword;

  useEffect(() => {
    if (keywordProp !== undefined) {
      return undefined;
    }
    const el = ref.current;
    if (!el) return undefined;
    const container = el.closest('.dbc-region-select-box');
    if (!container) return undefined;
    const searchInput = container.querySelector<HTMLInputElement>(
      '.dba-kb-panel-search-input, .dbc-region-select-search-input',
    );
    if (!searchInput) return undefined;
    setDomKeyword(searchInput.value || '');
    const handleInput = () => setDomKeyword(searchInput.value || '');
    searchInput.addEventListener('input', handleInput);
    return () => searchInput.removeEventListener('input', handleInput);
  }, [keywordProp]);

  return (
    <span ref={ref}>
      <HighlightText name={name} keyword={keyword} ellipsis className={className} />
    </span>
  );
};

export default SearchAwareText;
